module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-dialog', {
    attrs: {
      "dialog-style": {
        'background-color': 'transparent',
        'z-index': 4999
      }
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.viewShowType === '0'),
      expression: "viewShowType === '0'"
    }],
    staticClass: "grant-dialog-container"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("授权提示")]), _vm._v(" "), _c('span', {
    staticClass: "notice"
  }, [_vm._v("点击确认即表明您同意用户协议，并进行相应业务授权。")]), _vm._v(" "), _c('div', {
    staticClass: "button-container"
  }, [_c('button', {
    on: {
      "click": _vm.cancelBtnClick
    }
  }, [_vm._v(_vm._s(_vm.showType === '0' ? '取消' : '下一次'))]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.sureBtnClick
    }
  }, [_vm._v("确定")])]), _vm._v(" "), (false) ? _c('span', {
    staticClass: "bottom-notice"
  }, [_vm._v("提示：授权后您将收到免费短信验证码(移动用户将自动订阅中国移动手机贷业务)")]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.viewShowType === '1'),
      expression: "viewShowType === '1'"
    }],
    staticClass: "grant-dialog-container2"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("短信验证码")]), _vm._v(" "), _c('div', {
    staticClass: "close-btn-container",
    on: {
      "click": _vm.closeSelf
    }
  }, [_c('icon', {
    staticClass: "close-icon",
    attrs: {
      "className": "icon",
      "symbol": "close-icon"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "middle-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.verifyCode),
      expression: "verifyCode"
    }],
    attrs: {
      "placeholder": "请输入验证码",
      "maxlength": "6"
    },
    domProps: {
      "value": (_vm.verifyCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.verifyCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    class: {
      'button-enable': _vm.verifyButtonEnable, 'button-disable': !_vm.verifyButtonEnable
    },
    attrs: {
      "disabled": !_vm.verifyButtonEnable
    },
    on: {
      "click": _vm.sendBtnClick
    }
  }, [_vm._v(_vm._s(_vm.verifyText) + "\n        ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNotice),
      expression: "showNotice"
    }],
    staticClass: "notice-container"
  }, [_c('icon', {
    staticClass: "notice-icon",
    attrs: {
      "className": "icon",
      "symbol": "red-notice-icon"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.noticeText))])], 1)]), _vm._v(" "), _c('button', {
    class: {
      'button-enable': _vm.validateBtnEnable, 'button-disable': !_vm.validateBtnEnable
    },
    attrs: {
      "disabled": !_vm.validateBtnEnable
    },
    on: {
      "click": _vm.validateVerifyCode
    }
  }, [_vm._v(_vm._s(_vm.isChecking ? '正在验证' : '确定') + "\n      ")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-10d6df84!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/common/xy-grant-view.vue
// module id = 389
// module chunks = 36